export default __webpack_public_path__ + "static/media/gill-sans-medium.6d4fc7f8.otf";